import { atom } from "jotai";
import { ComplaintDTO } from "../types/ComplaintDTO";
import { DeliveryDocumentsByGroupDTO } from "../types/DeliveryDocumentsByGroupDTO";
import { TemplateDTO } from "../types/TemplateDTO";

export const userTypeAtom = atom("" as string | null);
export const regionId = atom(null as number | null);
export const modalEditAccount = atom(false);
export const modalDeleteAccount = atom(false);
export const modalDeleteCompany = atom(null as number | null);
export const modalForms = atom(false);
export const modalQR = atom(false);
export const modalInfoForm = atom(false);
export const modalDivergences = atom(false);
export const modalIgnoreDivergences = atom(false);
export const modalDeleteIgnoredDivergence = atom(false);
export const modalImportAnswers = atom(false);
export const modalEmployeePending = atom(false);
export const modalEvents = atom(false);
export const modalDownloads = atom(false);
export const modalDocumentGroup = atom(false);
export const modalNewDeliveryCompany = atom(false);
export const modalNewDeliveryDocument = atom(false);
export const modalQrCodeWhatsApp = atom(false);
export const modalConfirmLogout = atom(false);
export const modalTemplate = atom(false);
export const modalConfirmSend = atom(false);
export const modalDeleteDelivery = atom(false);
export const modalAdmissionEmployee = atom(false);
export const modalNewAdmission = atom(false);
export const complaintEdit = atom({} as ComplaintDTO);
export const templateEditAtom = atom<TemplateDTO | null>(null);
export const documentsAtom = atom(null as DeliveryDocumentsByGroupDTO | null);
export const selectedDocumentsAtom = atom([] as number[]);
export const permissionsAtom = atom([] as string[]);